import { render } from "./UpdateDataStream.vue?vue&type=template&id=6462f1bc&scoped=true"
import script from "./UpdateDataStream.vue?vue&type=script&lang=js"
export * from "./UpdateDataStream.vue?vue&type=script&lang=js"

import "./UpdateDataStream.vue?vue&type=style&index=0&id=6462f1bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6462f1bc"]])

export default __exports__